<div class="p-3" cdkFocusRegionstart>
  <div id="preview">
    <h3 class="pb-2">EMAIL PREVIEW</h3>
    <div class="flex-row"><strong>From:&nbsp;</strong>{{previewData.from}}</div>
    <div class="flex-row"><strong>To:&nbsp;</strong>{{previewData.email}}</div>
    <div class="flex-row"><strong>Reply-To:&nbsp;</strong>{{previewData.replyTo}}</div>
    <div class="flex-row"><strong>Subject:&nbsp;</strong>{{previewData.subject}}</div>
    <br>
      <hr />
      <br>
        @if (previewData.body) {
          <quill-view-html [content]="previewData.body"></quill-view-html>
        }
      </div>
      <div class="flex-row justify-end items-center">
        <button mat-button color="primary" class="uppercase p-0" (click)=onCloseClick()>
          <span class="text-bold">close</span>
        </button>
      </div>
    </div>
